<template>
  <teleport to="body">
    <div class="debug-modal-backdrop" @click.self="$emit('close')">
      <div class="modal-content" :style="{ width: modalWidth, maxWidth: '95vw' }">
        <div class="modal-header">
          <h3 class="modal-title">{{ $t('anadir_incidencia') }}</h3>
          <button type="button" class="btn-close" @click.stop="cerrar" aria-label="Cerrar" title="Cerrar">
            <span class="material-icons action-icon">close</span>
          </button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="handleSubmit($event)" @keydown.enter.prevent>
            <!-- Select de Usuario (primero): quien tiene la incidencia. Visible para roles != 4 -->
            <div class="form-group" v-if="Number(userRole) !== 4">
              <label for="usuario_id" class="form-label">{{ $t('usuario') }}</label>
              <select id="usuario_id" v-model="form.usuario_id" class="form-control">
                <option v-for="u in users" :key="u.id" :value="u.id">{{ u.nombre }}</option>
              </select>
              
            </div>
            <div class="form-group">
              <label for="categoria" class="form-label">{{ $t('categoria') }}</label>
              <select id="categoria" v-model="form.categoria" class="form-control" required>
                <option value="" disabled>{{ $t('seleccione_categoria') }}</option>
                <option v-for="categoria in availableCategorias" :key="categoria.id" :value="categoria.id">
                  {{ getCategoriaTraducida(categoria.nombre) }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="prioridad" class="form-label">{{ $t('prioridad') }}</label>
              <select id="prioridad" v-model="form.prioridad" class="form-control" required>
                <option value="" disabled>{{ $t('seleccione_prioridad') }}</option>
                <option v-for="prioridad in prioridades" :key="prioridad.id" :value="prioridad.id">
                  {{ $t('nivel_' + prioridad.nombre.toLowerCase()) }}
                </option>
              </select>
            </div>

            

            <div class="form-group">
              <label class="form-label">{{ showFichajeForm ? $t('fichaje') : $t('descripcion') }}</label>
              <template v-if="showFichajeForm">
                <div>
                  <div style="margin-bottom:8px;">
                    <label class="form-label">{{ $t('fecha') }}</label>
                    <input type="date" v-model="ticketFichaje.fecha" class="form-control" />
                  </div>

                  <div class="text-muted small" style="margin-bottom:8px; color:#495057;">{{ $t('fichaje_instrucciones') }}</div>

                  <!-- Grupo: Turno de mañana / jornada intensiva -->
                  <div style="margin-bottom:8px; padding:8px; border:1px solid #eee; border-radius:6px;">
                    <div style="font-weight:600; margin-bottom:6px;">{{ $t('turno_manana_jornada') || 'Turno de mañana / jornada intensiva' }}</div>
                    <div style="display:flex; gap:12px; align-items:center;">
                      <div style="display:flex; align-items:center; gap:8px; flex:1 1 180px; min-width:120px;">
                        <label class="form-label" style="margin:0; white-space:nowrap;">{{ $t('hora_inicio_manana') || 'Hora inicio mañana' }}</label>
                        <input type="time" v-model="ticketFichaje.hora_inicio_manana" class="form-control" style="flex:1; max-width:120px;" />
                      </div>
                      <div style="display:flex; align-items:center; gap:8px; flex:1 1 180px; min-width:120px;">
                        <label class="form-label" style="margin:0; white-space:nowrap;">{{ $t('hora_fin_manana') || 'Hora fin mañana' }}</label>
                        <input type="time" v-model="ticketFichaje.hora_fin_manana" class="form-control" style="flex:1; max-width:120px;" />
                      </div>
                    </div>
                  </div>

                  <!-- Grupo: Turno de tarde -->
                  <div style="margin-bottom:8px; padding:8px; border:1px solid #eee; border-radius:6px;">
                    <div style="font-weight:600; margin-bottom:6px;">{{ $t('turno_tarde') || 'Turno de tarde' }}</div>
                    <div style="display:flex; gap:12px; align-items:center;">
                      <div style="display:flex; align-items:center; gap:8px; flex:1 1 180px; min-width:120px;">
                        <label class="form-label" style="margin:0; white-space:nowrap;">{{ $t('hora_inicio_tarde') || 'Hora inicio tarde' }}</label>
                        <input type="time" v-model="ticketFichaje.hora_inicio_tarde" class="form-control" style="flex:1; max-width:120px;" />
                      </div>
                      <div style="display:flex; align-items:center; gap:8px; flex:1 1 180px; min-width:120px;">
                        <label class="form-label" style="margin:0; white-space:nowrap;">{{ $t('hora_fin_tarde') || 'Hora fin tarde' }}</label>
                        <input type="time" v-model="ticketFichaje.hora_fin_tarde" class="form-control" style="flex:1; max-width:120px;" />
                      </div>
                    </div>
                  </div>

                  <div style="margin-top:4px; display:flex; align-items:center; gap:8px;">
                    <input type="checkbox" id="consentimiento" v-model="ticketFichaje.consentimiento" />
                    <label for="consentimiento">{{ $t('consentimiento') }}</label>
                  </div>
                </div>
              </template>
              <template v-else>
                <textarea
                  id="descripcion"
                  v-model="form.descripcion"
                  class="form-control"
                  required
                  :maxlength="maxDescripcion"
                  @input="onDescripcionInput"
                ></textarea>
                <div class="text-muted small" style="text-align: right; margin-top:6px;">
                  {{ (maxDescripcion - (form.descripcion ? form.descripcion.length : 0)) }} {{ $t('caracteres_restantes') || 'caracteres restantes' }}
                </div>
                <div class="form-group">
              <label class="form-label">{{ $t('archivos_adjuntos') }}</label>
              <input
                id="archivos"
                type="file"
                multiple
                accept=".pdf,image/*"
                style="display: none;"
                ref="fileInput"
                @change="addFiles"
              />
              <button
                type="button"
                class="btn btn-elegir-archivo"
                :disabled="isReadOnly"
                @click="!isReadOnly && $refs.fileInput.click()"
              >
                {{ $t('elegir_archivos') }}
              </button>
            </div>

            <div v-if="selectedFiles.length" class="form-group">
              <label class="form-label">{{ $t('archivos_seleccionados') }}</label>
              <div class="adjuntos-scroll">
                <ul style="list-style:none; padding:0; margin:0;">
                  <li v-for="(file, idx) in selectedFiles" :key="idx" style="display:flex; align-items:center; border-bottom:1px solid #eee; padding:6px 0;">
                    <div style="flex:1 0 120px; min-width:120px;">
                      <template v-if="renameIndex === idx">
                        <input v-model="renameBase" style="width: 120px;" type="text" :placeholder="getBaseName(file.name)" autofocus />
                        .{{ getExtension(file.name) }}
                        <button type="button" @click="confirmRename(idx)" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('confirmar_nombre')">
                          <span class="material-icons action-icon">check_circle</span>
                        </button>
                        <button type="button" @click="cancelRenameEdit" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('cancelar_edicion')">
                          <span class="material-icons action-icon">close</span>
                        </button>
                      </template>
                      <template v-else>
                        {{ file.name }}
                      </template>
                    </div>

                    <div style="flex:2 1 0; min-width:160px; max-width:100%;">
                      <span v-if="commentIndex === idx">
                        <input v-model="commentValue" style="width: 90%;" type="text" :placeholder="$t('comentario_opcional')" autofocus />
                        <button type="button" @click="confirmComment(idx)" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('confirmar_comentario')">
                          <span class="material-icons action-icon">check_circle</span>
                        </button>
                        <button type="button" @click="cancelCommentEdit" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('cancelar_edicion')">
                          <span class="material-icons action-icon">close</span>
                        </button>
                      </span>
                      <span v-else>
                        <span v-if="file.comentario">{{ file.comentario.length > 40 ? file.comentario.slice(0, 40) + '...' : file.comentario }}</span>
                        <a v-if="file.comentario && file.comentario.length > 40 && expandedComment !== idx" href="#" @click.prevent="expandedComment = idx" style="color:#99172A; margin-left:5px;">{{ $t('ver_mas') }}</a>
                        <template v-if="expandedComment === idx">
                          {{ file.comentario }}
                          <a href="#" @click.prevent="expandedComment = null" style="color:#99172A; margin-left:5px;">{{ $t('ver_menos') }}</a>
                        </template>
                      </span>
                    </div>

                    <div style="display:flex; gap:2px; min-width:120px; justify-content:flex-end;">
                      <!-- Botón de previsualizar -->
                      <button type="button" class="btn-preview" :title="$t('previsualizar')" @click="previewFile(file)">
                        <span class="material-icons action-icon" style="font-size:18px;">visibility</span>
                      </button>
                      <button type="button" @click="startRename(idx)" style="background:none; border:none; cursor:pointer;" :title="$t('renombrar')">
                        <span class="material-icons action-icon">edit_square</span>
                      </button>
                      <button type="button" @click="toggleComment(idx)" style="background:none; border:none; cursor:pointer;" :title="file.comentario ? $t('editar_comentario') : $t('anadir_comentario')">
                        <span class="material-icons action-icon">comment</span>
                      </button>
                      <button type="button" @click="downloadFile(file)" style="background:none; border:none; cursor:pointer;" :title="$t('descargar_archivo')">
                        <span class="material-icons action-icon">download</span>
                      </button>
                      <button type="button" @click="removeFile(idx)" style="background:none; border:none; cursor:pointer;" :title="$t('eliminar')">
                        <span class="material-icons action-icon">delete</span>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="ticketFiles.length" class="form-group">
              <label class="form-label">{{ $t('archivos_ya_subidos') }}</label>
              <ul>
                <li v-for="file in ticketFiles" :key="file.id">
                  <a :href="getDownloadUrl(file.id)" target="_blank">{{ file.filename }}</a>
                </li>
              </ul>
            </div>
              </template>
            </div>

            

            <div class="form-actions">
              <button type="submit" class="btn btn-primary" :disabled="isSaving || !formIsValid" :title="(!formIsValid ? ($t('formulario_incompleto') || 'Completa los campos obligatorios') : '')">
                <span v-if="isSaving">{{ $t('guardando') }}…</span>
                <span v-else>{{ $t('guardar') }}</span>
              </button>
              <button type="button" class="btn-cancel" @click.stop="cerrar">Cancelar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>

  <!-- PreviewModal -->
  <PreviewModal
    v-if="previewVisible"
    :visible="previewVisible"
    :file="previewFileObj"
    :previewUrl="previewObjectUrl"
    @close="closePreview"
    @download="handlePreviewDownload"
  />
</template>

<script>
import api from '../api';
import { showAlert } from '@/utils/alerts';
import Swal from 'sweetalert2';
import PreviewModal from '@/components/PreviewModal.vue';

export default {
  name: 'TicketFormModalView',
  components: { PreviewModal },
  emits: ['close','submit'],
  data() {
    return {
  form: { categoria: '', prioridad: 1, descripcion: '', estado: 1, usuario_id: null, usuario_asignado_id: null },
      categorias: [],
      estados: [],
  users: [],
  userRole: null,
    loggedUserId: null,
      prioridades: [
        { id: 1, nombre: 'Baja' },
        { id: 2, nombre: 'Media' },
        { id: 3, nombre: 'Alta' },
      ],
      selectedFiles: [],
      ticketFiles: [],
      ticketFichaje: {
        fecha: '',
        hora_inicio_manana: '',
        hora_fin_manana: '',
        hora_inicio_tarde: '',
        hora_fin_tarde: '',
        consentimiento: false
      },
      // Estado de previsualización
      previewVisible: false,
      previewFileObj: null,        // Objeto que se pasa a PreviewModal
      previewObjectUrl: '',        // URL temporal para archivos locales
      renameIndex: null,
      renameBase: '',
      commentIndex: null,
      commentValue: '',
      expandedComment: null,
      isSaving: false,
      uploadProgress: 0,
      maxDescripcion: 1500,
    };
  },
  computed: {
    modalWidth() {
      const minWidth = window.innerWidth * 0.4;
      const maxWidth = window.innerWidth * 0.95;
      const width = this.selectedFiles.length > 0 ? Math.min(maxWidth, Math.max(minWidth, 800)) : minWidth;
      return `${width}px`;
    },

    isReadOnly() {
      return false;
    },

    availableCategorias() {
      try {
        if (!Array.isArray(this.categorias)) return [];
        if (this.loggedUserId == null) return this.categorias;
        if (this.form.usuario_id != null && Number(this.form.usuario_id) !== Number(this.loggedUserId)) {
          return this.categorias.filter(c => Number(c.id) !== 4);
        }
        return this.categorias;
      } catch (e) {
        return this.categorias || [];
      }
    },

    showFichajeForm() {
      try {
        return Number(this.form.categoria) === 4 && this.isCategoria4Allowed();
      } catch (e) {
        return false;
      }
    },

    // Computed que devuelve si el formulario cumple los requisitos mínimos para activar Guardar
    formIsValid() {
      try {
        const hasCategoria = this.form.categoria !== '' && this.form.categoria != null;
        const hasPrioridad = this.form.prioridad !== '' && this.form.prioridad != null;
        const hasUsuario = this.form.usuario_id !== '' && this.form.usuario_id != null;

        if (!hasCategoria || !hasPrioridad || !hasUsuario) return false;

        if (Number(this.form.categoria) === 4 && this.showFichajeForm) {
          if (!this.ticketFichaje.fecha) return false;
          const anyHour = this.ticketFichaje.hora_inicio_manana || this.ticketFichaje.hora_fin_manana || this.ticketFichaje.hora_inicio_tarde || this.ticketFichaje.hora_fin_tarde;
          if (!anyHour) return false;
          if (!this.ticketFichaje.consentimiento) return false;
          return true;
        }

        const desc = this.form.descripcion || '';
        return desc.trim().length > 0;
      } catch (e) {
        return false;
      }
    }
  },
  async created() {
    await this.loadCategorias();
    await this.loadEstados();
    // Leer rol y user_id de sesión si existen
    try {
      const storedRole = sessionStorage.getItem('user_role');
      this.userRole = storedRole != null ? Number(storedRole) : null;
      const storedUserId = sessionStorage.getItem('user_id');
      this.form.usuario_id = storedUserId != null ? Number(storedUserId) : this.form.usuario_id;
    } catch (e) {
      this.userRole = null;
    }

    await this.loadUsers();
    // Asegurar que la descripción inicial no supere el tope
    if (this.form.descripcion && this.form.descripcion.length > this.maxDescripcion) {
      this.form.descripcion = this.form.descripcion.slice(0, this.maxDescripcion);
    }

    // Guardar el id del usuario logueado para reglas de UI
    try {
      const storedUserId = sessionStorage.getItem('user_id');
      this.loggedUserId = storedUserId != null ? Number(storedUserId) : null;
      // Comprobar estado inicial de la categoría en función del usuario (cubre el caso categoria seleccionada antes que usuario)
      this.checkCategoriaAllowedAndClear('created');
      // Si tras la comprobación la ficha de fichaje está activa, asegurar fecha por defecto
      try {
        if (this.showFichajeForm && !this.ticketFichaje.fecha) {
          this.ticketFichaje.fecha = this.getTodayDateString();
        }
      } catch (e) { /* noop */ }
    } catch (e) {
      // noop
    }
  },
  mounted() {
    this._escHandler = (e) => { if (e.key === 'Escape') this.$emit('close'); };
    window.addEventListener('keydown', this._escHandler);

    // Vigilar cambios en el usuario seleccionado y en la categoría; usar funciones helper centralizadas
    this._unwatchUsuario = this.$watch('form.usuario_id', (newVal, oldVal) => {
      try {
        this.checkCategoriaAllowedAndClear('usuario_change');
      } catch (e) { /* noop */ }
    });

    this._unwatchCategoria = this.$watch('form.categoria', (newVal, oldVal) => {
      try {
        this.checkCategoriaAllowedAndClear('categoria_change');
        // Si la ficha de fichaje se ha activado, asegurar fecha por defecto
        if (this.showFichajeForm && !this.ticketFichaje.fecha) {
          this.ticketFichaje.fecha = this.getTodayDateString();
        }
      } catch (e) { /* noop */ }
    });
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._escHandler);
    // Limpiar URLs temporales
    if (this.previewObjectUrl) {
      try { URL.revokeObjectURL(this.previewObjectUrl); } catch(e) { /* noop */ }
    }
    if (this._unwatchUsuario) {
      try { this._unwatchUsuario(); } catch(e) { /* noop */ }
      this._unwatchUsuario = null;
    }
    if (this._unwatchCategoria) {
      try { this._unwatchCategoria(); } catch(e) { /* noop */ }
      this._unwatchCategoria = null;
    }
  },
  methods: {
    cerrar() { this.$emit('close'); },
    
    getCategoriaTraducida(nombreCategoria) {
      const mapeo = {
        "Hardware": "hardware",
        "Software": "software",
        "Redes y conectividad": "redes",
        "Correo Electronico": "correo",
        "Accesos y contraseñas": "acceso",
        "Impresion y escaneo": "impresion",
        "Seguridad": "seguridad",
        "Telefonia": "telefonia",
        "Aplicaciones Web / Intranet": "web",
        "Otros": "otros"
      };
      const clave = mapeo[nombreCategoria];
      if (clave && this.$t(`categorias_traducidas.${clave}`) !== `categorias_traducidas.${clave}`) {
        return this.$t(`categorias_traducidas.${clave}`);
      }
      return nombreCategoria;
    },
    
    async loadCategorias() {
      try {
        console.log('Cargando categor\u00edas...');
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticaci\u00f3n');
          return;
        }
        
        const response = await api.get('/tickets/categorias', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        this.categorias = response.data.categorias ?? response.data ?? [];
        console.log('Categor\u00edas cargadas:', this.categorias.length);
      } catch (error) {
        console.error('Error cargando categor\u00edas:', error);
        await showAlert('error', this.$t('error_cargar_categorias') || 'Error', '', { 
          html: this.$t('error_cargar_categorias') || 'Error cargando categor\u00edas' 
        });
      }
    },
    
    async loadEstados() {
      try {
        console.log('Cargando estados...');
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticaci\u00f3n');
          return;
        }
        
        const response = await api.get('/tickets/estados', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        this.estados = response.data.estados ?? response.data ?? [];
        console.log('Estados cargados:', this.estados.length);
      } catch (error) {
        console.error('Error cargando estados:', error);
        await showAlert('error', this.$t('error_cargar_estados') || 'Error', '', { 
          html: this.$t('error_cargar_estados') || 'Error cargando estados' 
        });
      }
    },

    async loadUsers() {
      try {
        console.log('Cargando usuarios...');
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticación para cargar usuarios');
          return;
        }

        const response = await api.get('/users/reduced-fields', {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        // Esperamos { data: [ { usuario_id, nombre_completo, delegacion_id, departamento_id }, ... ] }
        const raw = response.data;
        const list = Array.isArray(raw.data) ? raw.data : [];

        this.users = list
          .map(u => ({
            id: u.usuario_id ?? u.id,
            nombre: u.nombre_completo ?? ((u.nombre || '') + ' ' + (u.apellidos || '')).trim(),
            delegacion_id: u.delegacion_id ?? null,
            departamento_id: u.departamento_id ?? null
          }))
          .filter(u => u.id != null);

        console.log('Usuarios cargados:', this.users.length);
      } catch (err) {
        console.error('Error cargando usuarios:', err, err.response?.data);
        // No mostrar alerta crítico aquí; el select es opcional
        this.users = [];
      }
    },
    
    addFiles(event) {
      const nuevos = Array.from(event.target.files || []);
      const MAX_BYTES = 15 * 1024 * 1024; // 15 MB
      const tooBig = nuevos.filter(f => f && f.size > MAX_BYTES);
      
      if (tooBig.length) {
        const names = tooBig.map(f => f.name).join(', ');
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          html: `Los siguientes archivos superan el límite de 15MB:<br><strong>${names}</strong>`,
          confirmButtonText: 'Aceptar'
        });
      }
      
      const acceptedBySize = nuevos.filter(f => f && f.size <= MAX_BYTES);
      const processed = acceptedBySize.map(f => this.sanitizeFileObj(f));
      
      const archivosValidos = processed.filter(file =>
        file.type === 'application/pdf' ||
        file.type?.startsWith?.('image/') ||
        /\.(pdf|jpg|jpeg|png|gif|webp|bmp|heic|heif)$/i.test(file.name)
      );
      
      if (archivosValidos.length < processed.length) {
        Swal.fire({
          icon: 'error',
          title: this.$t('solo_imagenes_pdf') || 'Solo PDF/imagen',
          html: this.$t('solo_imagenes_pdf') || 'Solo se permiten PDF o imágenes',
          confirmButtonText: 'Aceptar'
        });
      }
      
      this.selectedFiles = [...this.selectedFiles, ...archivosValidos];
      event.target.value = "";
    },
    
    removeFile(idx) {
      this.selectedFiles.splice(idx, 1);
    },

    onDescripcionInput(e) {
      if (!this.form.descripcion) return;
      if (this.form.descripcion.length > this.maxDescripcion) {
        this.form.descripcion = this.form.descripcion.slice(0, this.maxDescripcion);
      }
    },
    
    async uploadFiles(ticketId) {
      try {
        console.log('=== INICIANDO SUBIDA DE ARCHIVOS ===');
        console.log('Ticket ID:', ticketId);
        console.log('Número de archivos:', this.selectedFiles.length);
        
  const token = sessionStorage.getItem('auth_token');
        if (!token) {
          throw new Error('No hay token de autenticación disponible');
        }
        
        for (const [index, file] of this.selectedFiles.entries()) {
          console.log(`Subiendo archivo ${index + 1}/${this.selectedFiles.length}:`, {
            nombre: file.name,
            tamaño: `${(file.size / 1024 / 1024).toFixed(2)} MB`,
            tipo: file.type,
            comentario: file.comentario || '(sin comentario)'
          });

          const formData = new FormData();
          
          // Usar el nombre original o sanitizado
          const safeName = this.sanitizeFileName(file.name || 'archivo');
          formData.append('file', file, safeName);
          
          // Solo añadir comentario si existe y no está vacío
          if (file.comentario && file.comentario.trim() !== '') {
            formData.append('comentario', file.comentario.trim());
          }

          // DEBUG: Ver contenido del FormData
          console.log('Contenido del FormData:');
          for (let [key, value] of formData.entries()) {
            console.log(`  ${key}:`, value instanceof File ? 
              `File(${value.name}, ${value.size} bytes, ${value.type})` : 
              `"${value}"`);
          }

          // CONFIGURACIÓN CON HEADERS DE AUTORIZACIÓN
          const config = {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (e) => {
              if (e.lengthComputable) {
                const progress = Math.round((e.loaded * 100) / e.total);
                this.uploadProgress = progress;
                console.log(`Progreso de ${file.name}: ${progress}%`);
              }
            }
          };

          console.log('Enviando petición POST a:', `/tickets/${ticketId}/upload-file`);
          
          try {
            const response = await api.post(`/tickets/${ticketId}/upload-file`, formData, config);
            console.log(`✅ Archivo "${file.name}" subido exitosamente`);
            console.log('Respuesta del servidor:', response.data);
          } catch (uploadError) {
            console.error(`❌ Error subiendo archivo "${file.name}":`, uploadError);
            console.error('Status:', uploadError.response?.status);
            console.error('Datos:', uploadError.response?.data);
            console.error('Headers:', uploadError.response?.headers);
            
            let errorMessage = `Error subiendo archivo "${file.name}"`;
            
            if (uploadError.response?.data) {
              const serverError = uploadError.response.data;
              console.error('Error del servidor:', serverError);
              
              if (serverError.message) {
                errorMessage = serverError.message;
              } else if (serverError.errors) {
                errorMessage = Object.values(serverError.errors).flat().join(', ');
              }
            }
            
            await showAlert('error', 'Error al subir archivo', '', {
              html: `<strong>Error:</strong><br>${errorMessage}`
            });
            
            throw uploadError;
          }
        }

        console.log('✅ Todos los archivos subidos exitosamente');
        this.selectedFiles = [];
        
        // Recargar archivos del ticket
        await this.fetchTicketFiles(ticketId);
        
      } catch (err) {
        console.error('❌ Error general en uploadFiles:', err);
        
        const errorMessage = err.message || 'Error de red al subir archivos';
        await showAlert('error', 'Error', '', { 
          html: `<strong>Error al subir archivos:</strong><br>${errorMessage}` 
        });
        
        throw err;
      } finally {
        this.uploadProgress = 0;
      }
    },
    
    async fetchTicketFiles(ticketId) {
      try {
        console.log(`Cargando archivos para ticket ${ticketId}...`);
        
  const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticación');
          return;
        }
        
        const response = await api.get(`/tickets/${ticketId}/files`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        console.log('Archivos cargados:', response.data.files?.length || 0);
        this.ticketFiles = response.data.files || [];
      } catch (err) {
        console.error('Error al cargar archivos:', err);
        console.error('Response:', err.response);
        
        const payload = err.response?.data || { message: err.message || 'Network error' };
        const msg = payload.message || 'Error cargando archivos';
        
        await showAlert('error', 'Error', '', { 
          html: `<strong>Error al cargar archivos:</strong><br>${msg}` 
        });
        
        this.ticketFiles = [];
      }
    },
    
    async handleSubmit(event) {
      const formEl = event?.currentTarget || (event?.target && event.target.form) || null;
      const submitBtn = formEl ? formEl.querySelector('button[type="submit"]') : null;

      if (this._submitting) return;
      this._submitting = true;
      this.isSaving = true;
      this.uploadProgress = 0;

      if (submitBtn) submitBtn.disabled = true;
      
      console.log('=== INICIANDO CREACIÓN DE TICKET ===');
      
      try {
        // Verificar token
  const token = sessionStorage.getItem('auth_token');
        if (!token) {
          throw new Error('No hay token de autenticación. Por favor, inicie sesión nuevamente.');
        }
        
        console.log('Token disponible: SÍ');

        // 1. Obtener perfil del usuario
        console.log('1. Obteniendo perfil del usuario...');
        const perfilResponse = await api.get('/users/perfil', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const usuarioLogueado = perfilResponse.data.user;
        console.log('Usuario logueado:', usuarioLogueado);
        // Asegurar que el campo usuario_id por defecto coincide con el usuario logueado
        try {
          const loggedId = usuarioLogueado?.id || usuarioLogueado?.user_id || null;
          if ((this.form.usuario_id == null || this.form.usuario_id === '') && loggedId != null) {
            this.form.usuario_id = Number(loggedId);
          }
        } catch (e) {
          // noop
        }
        
        // Obtener delegacion/departamento del usuario logueado por defecto
        let delegacionId = parseInt(usuarioLogueado.delegacion_id, 10);
        let departamentoId = parseInt(usuarioLogueado.departamento_id, 10);

        // Detectar si el usuario logueado es operador (rol 4)
        const loggedRole = usuarioLogueado?.rol_id != null ? Number(usuarioLogueado.rol_id) : (this.userRole != null ? Number(this.userRole) : null);
        const isOperador = loggedRole === 4;

        // Si NO es operador y se ha seleccionado explícitamente un usuario en el select,
        // usar la delegación/departamento de ese usuario seleccionado (si están disponibles).
        if (!isOperador && this.form.usuario_id != null) {
          try {
            const sel = this.users.find(u => Number(u.id) === Number(this.form.usuario_id));
            if (sel) {
              const selDeleg = sel.delegacion_id != null ? parseInt(sel.delegacion_id, 10) : NaN;
              const selDept = sel.departamento_id != null ? parseInt(sel.departamento_id, 10) : NaN;
              if (!isNaN(selDeleg)) delegacionId = selDeleg;
              if (!isNaN(selDept)) departamentoId = selDept;
            }
          } catch (e) {
            // noop - si algo falla, mantenemos las IDs del usuario logueado
            console.warn('No se pudo obtener delegacion/departamento del usuario seleccionado:', e);
          }
        }

        // Si es operador, forzar usuario_id y los datos de delegacion/departamento al usuario logueado
        if (isOperador) {
          const loggedId = usuarioLogueado?.id || usuarioLogueado?.user_id || null;
          if (loggedId != null) {
            this.form.usuario_id = Number(loggedId);
          }
          // Asegurarse de que delegacion/departamento son válidos
          if (isNaN(delegacionId) || isNaN(departamentoId)) {
            throw new Error('delegacion_id o departamento_id del usuario logueado no son válidos.');
          }
        } else {
          if (isNaN(delegacionId) || isNaN(departamentoId)) {
            throw new Error('delegacion_id o departamento_id no son válidos.');
          }
        }

        console.log('2. IDs obtenidos - delegacion:', delegacionId, 'departamento:', departamentoId, 'isOperador:', isOperador);

        // 2. Preparar payload
        const categoriaSeleccionada = this.categorias.find(cat => cat.id === Number(this.form.categoria));
        // Valor por defecto desde la categoría (si la categoría define un usuario de notificación)
        const usuarioAsignadoIdFromCategory = categoriaSeleccionada && categoriaSeleccionada.id_user_notification
          ? categoriaSeleccionada.id_user_notification
          : null;

        // Si el formulario incluye explícitamente un usuario asignado, darle prioridad
        const usuarioAsignadoId = (this.form.usuario_asignado_id || this.form.usuario_asignado_id === 0)
          ? Number(this.form.usuario_asignado_id)
          : usuarioAsignadoIdFromCategory;

        // Si es ficha de fichaje (categoria 4) generamos la descripción a partir de los datos disponibles
        const descripcionPayload = (Number(this.form.categoria) === 4) ? this.buildFichajeDescription() : this.form.descripcion;

        const payload = {
          delegacion_id: delegacionId,
          departamento_id: departamentoId,
          categoria_id: this.form.categoria,
          prioridad_id: this.form.prioridad,
          estado_id: 1,
          descripcion: descripcionPayload,
          usuario_asignado_id: usuarioAsignadoId || null,
          // El propietario del ticket (usuario que tiene la incidencia). Por defecto coincide con el usuario logueado.
          usuario_id: this.form.usuario_id != null ? Number(this.form.usuario_id) : null,
        };
        
        console.log('3. Payload para crear ticket:', payload);

        // Si estamos en fichaje, validar campos mínimos antes de crear
        if (Number(this.form.categoria) === 4 && this.showFichajeForm) {
          const valid = this.validateTicketFichaje();
          if (!valid.ok) {
            await Swal.fire({ icon: 'error', title: this.$t('error') || 'Error', html: valid.msg, confirmButtonText: this.$t('aceptar') || 'Aceptar' });
            throw new Error('Validation failed: ' + valid.msg);
          }
        }

        // 3. Crear ticket con headers
        console.log('4. Creando ticket...');
        const response = await api.post('/tickets', payload, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        const ticketCreado = response.data.ticket;
        console.log('5. Ticket creado:', ticketCreado);

        // Si la categoría es 4 y el formulario de fichaje está visible, crear también el registro ticket_fichaje
        try {
          if (Number(this.form.categoria) === 4 && this.showFichajeForm) {
            const normalize = (t) => this.normalizeTimeWithSeconds(t);
            const fichajePayload = {
              ticket_id: ticketCreado.id,
              usuario_id: Number(this.form.usuario_id),
              fecha: this.ticketFichaje.fecha || null,
              hora_inicio_manana: normalize(this.ticketFichaje.hora_inicio_manana) || null,
              hora_fin_manana: normalize(this.ticketFichaje.hora_fin_manana) || null,
              hora_inicio_tarde: normalize(this.ticketFichaje.hora_inicio_tarde) || null,
              hora_fin_tarde: normalize(this.ticketFichaje.hora_fin_tarde) || null,
              consentimiento: this.ticketFichaje.consentimiento ? 1 : 0
            };
            console.log('Creando ticket_fichaje con payload:', fichajePayload);
            await api.post('/tickets/fichaje', fichajePayload, { headers: { 'Authorization': `Bearer ${sessionStorage.getItem('auth_token')}` } });
            console.log('ticket_fichaje creado');
          }
        } catch (errF) {
          console.error('Error creando ticket_fichaje:', errF, errF?.response?.data);
        }

        // 4. Subir archivos si hay
        if (this.selectedFiles.length) {
          console.log(`6. Subiendo ${this.selectedFiles.length} archivos...`);
          await this.uploadFiles(ticketCreado.id);
        } else {
          console.log('6. No hay archivos para subir');
        }

        // 5. Mostrar mensaje de éxito
        const title = this.$t ? this.$t('ticket_creado_exitosamente') : 'Ticket creado';
        const translated = this.$t ? this.$t('ticket_creado_text', { id: ticketCreado.id }) : null;
        const htmlMessage = translated && typeof translated === 'string' && translated.includes(String(ticketCreado.id))
          ? translated
          : `Ticket creado con ID ${ticketCreado.id}.`;
        
        await Swal.fire({
          icon: 'success',
          title,
          html: htmlMessage,
          target: 'body',
          position: 'center',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });
        
        console.log('7. Operación completada con éxito');
        // Dispatch a global event so other views (e.g. WelcomeView) can react and reload lists
        try {
          window.dispatchEvent(new CustomEvent('ticketCreated', { detail: ticketCreado }));
        } catch (e) {
          // ignore if dispatching fails in some environments
          console.warn('No se pudo despachar evento global ticketCreated', e);
        }
        this.$emit('submit', ticketCreado);
        this.$emit('close');
        
      } catch (error) {
        console.error('=== ERROR EN CREACIÓN DE TICKET ===');
        console.error('Error completo:', error);
        console.error('Error response:', error.response);
        
        let errorMsg = error.response?.data?.message || error.message;
        if (error.response?.data?.errors) {
          errorMsg += '\n' + JSON.stringify(error.response.data.errors);
        }
        
        await showAlert('error', this.$t('error_crear_ticket') || 'Error', '', { 
          html: `<strong>Error creando ticket:</strong><br>${errorMsg}` 
        });
      } finally {
        this._submitting = false;
        if (submitBtn) submitBtn.disabled = false;
        setTimeout(() => {
          this.isSaving = false;
          this.uploadProgress = 0;
        }, 150);
      }
    },
    
    // Método para previsualizar archivos
    async previewFile(file) {
      console.log('[previewFile] called with:', file);
      
      // Limpiar preview anterior
      if (this.previewObjectUrl) {
        try { 
          URL.revokeObjectURL(this.previewObjectUrl); 
        } catch(e) { /* ignore */ }
        this.previewObjectUrl = '';
      }
      
      // Si es un archivo File (local)
      if (file instanceof File) {
        try {
          const url = URL.createObjectURL(file);
          this.previewObjectUrl = url;
          // Estructura que PreviewModal espera
          this.previewFileObj = {
            file: file,
            name: file.name,
            type: file.type
          };
          this.previewVisible = true;
          document.body.classList.add('preview-open');
          return;
        } catch (e) {
          console.error('Error creating objectURL:', e);
          await showAlert('error', 'Error', '', { html: 'No se pudo previsualizar el archivo' });
          return;
        }
      }
      
      // Si es un archivo remoto (con id)
      if (file && file.id) {
        try {
          const token = sessionStorage.getItem('auth_token');
          const response = await api.get(`/tickets/files/download/${file.id}`, {
            responseType: 'blob',
            headers: { 
              'Authorization': `Bearer ${token}` 
            }
          });
          const blob = response.data;
          const url = URL.createObjectURL(blob);
          this.previewObjectUrl = url;
          this.previewFileObj = {
            id: file.id,
            filename: file.filename || file.name || 'archivo',
            type: blob.type
          };
          this.previewVisible = true;
          document.body.classList.add('preview-open');
        } catch (err) {
          console.error('Error descargando archivo para preview:', err, err.response?.data);
          await showAlert('error', 'Error', '', { html: 'No se pudo previsualizar el archivo' });
        }
        return;
      }
      
      // Si no es un tipo válido
      await showAlert('error', 'Error', '', { html: 'No se puede previsualizar este archivo' });
    },
    
    closePreview() {
      if (this.previewObjectUrl) {
        try { 
          URL.revokeObjectURL(this.previewObjectUrl); 
        } catch(e) { /* ignore */ }
      }
      this.previewObjectUrl = '';
      this.previewFileObj = null;
      this.previewVisible = false;
      document.body.classList.remove('preview-open');
    },
    
    // Método para manejar la descarga desde PreviewModal
    handlePreviewDownload(payload) {
      const file = payload?.file || payload || this.previewFileObj;
      if (file) {
        this.downloadFile(file);
      }
    },
    
    downloadFile(file) {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else if (file.file_url || file.url) {
        const a = document.createElement('a');
        a.href = file.file_url || file.url;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        showAlert('error', this.$t('no_previsualizar_archivo') || 'No disponible', '', { 
          html: this.$t('no_previsualizar_archivo') || 'No se puede previsualizar el archivo' 
        });
      }
    },
    
    // Métodos para renombrar archivos
    startRename(idx) {
      this.renameIndex = idx;
      this.renameBase = this.getBaseName(this.selectedFiles[idx].name);
    },
    
    confirmRename(idx) {
      if (this.renameBase.trim() === '') {
        this.showToast && this.showToast(this.$t('nombre_obligatorio'), "error");
        return;
      }
      
      const oldFile = this.selectedFiles[idx];
      const ext = this.getExtension(oldFile.name);
      const newNameRaw = ext ? `${this.renameBase}.${ext}` : this.renameBase;
      const newName = this.sanitizeFileName(newNameRaw);
      
      try {
        const renamedFile = new File([oldFile], newName, { 
          type: oldFile.type, 
          lastModified: oldFile.lastModified 
        });
        renamedFile.comentario = oldFile.comentario;
        this.selectedFiles.splice(idx, 1, renamedFile);
      } catch (e) {
        oldFile.name = newName;
        this.selectedFiles.splice(idx, 1, oldFile);
      }
      
      this.renameIndex = null;
      this.renameBase = '';
    },
    
    cancelRenameEdit() {
      this.renameIndex = null;
      this.renameBase = '';
    },
    
    getBaseName(filename) {
      const lastDot = filename.lastIndexOf('.');
      return lastDot === -1 ? filename : filename.substring(0, lastDot);
    },
    
    getExtension(filename) {
      const lastDot = filename.lastIndexOf('.');
      return lastDot === -1 ? '' : filename.substring(lastDot + 1);
    },
    
    // Métodos para comentarios
    toggleComment(idx) {
      if (this.commentIndex === idx) {
        this.commentIndex = null;
        this.commentValue = '';
      } else {
        this.commentIndex = idx;
        this.commentValue = this.selectedFiles[idx].comentario || '';
      }
    },
    
    confirmComment(idx) {
      const file = this.selectedFiles[idx];
      file.comentario = this.commentValue.trim() === '' ? '' : this.commentValue;
      this.commentIndex = null;
      this.commentValue = '';
    },
    
    cancelCommentEdit() {
      this.commentIndex = null;
      this.commentValue = '';
    },
    
    getDownloadUrl(fileId) {
  const token = sessionStorage.getItem('auth_token');
      return `/api/tickets/files/download/${fileId}?token=${token}`;
    },
    
    // Métodos para sanitizar nombres de archivos
    sanitizeFileName(filename = '') {
      const MAX_TOTAL = 25;
      const MAX_EXT = 12;
      const lastDot = filename.lastIndexOf('.');
      let base = lastDot === -1 ? filename : filename.substring(0, lastDot);
      let ext = lastDot === -1 ? '' : filename.substring(lastDot + 1);
      
      base = base.replace(/[^a-zA-Z0-9-_\.]/g, '_').replace(/_+/g, '_');
      ext = ext.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      
      if (ext.length > MAX_EXT) ext = ext.substring(0, MAX_EXT);
      const remaining = ext ? MAX_TOTAL - (ext.length + 1) : MAX_TOTAL;
      
      if (base.length > remaining) base = base.substring(0, remaining);
      const result = ext ? `${base}.${ext}` : base;
      
      return result || 'file';
    },
    
    sanitizeFileObj(file) {
      if (!file) return file;
      const safeName = this.sanitizeFileName(file.name || 'file');
      
      if (safeName === file.name) return file;
      
      try {
        const newFile = new File([file], safeName, { 
          type: file.type, 
          lastModified: file.lastModified 
        });
        if (file.comentario) newFile.comentario = file.comentario;
        return newFile;
      } catch (e) {
        file.name = safeName;
        return file;
      }
    },
    
    showToast(message, type = 'info') {
      // Implementación de toast aquí
      console.log(`${type}: ${message}`);
    }
    ,
    // Helper: devuelve true si la categoria 4 está permitida dado el usuario seleccionado y el usuario logueado
    isCategoria4Allowed() {
      try {
        if (this.loggedUserId == null) return true; // comportamiento conservador: si no sabemos, permitimos
        if (this.form.usuario_id == null) return true; // si no hay usuario seleccionado todavía, no bloquear
        return Number(this.form.usuario_id) === Number(this.loggedUserId);
      } catch (e) {
        return true;
      }
    },
    // Comprueba y limpia la categoría 4 si no está permitida; opcionalmente pasa una etiqueta para logging
    checkCategoriaAllowedAndClear(source = '') {
      try {
        // Si la categoría actual es 4 y no está permitida, limpiar y notificar
        if (Number(this.form.categoria) === 4 && !this.isCategoria4Allowed()) {
          this.form.categoria = '';
          // Reset fichaje fields cuando se borra la categoría 4
          this.resetTicketFichaje();
          console.info(`[TicketFormModal] checkCategoriaAllowedAndClear: cleared categoria due to ${source}`);
          Swal.fire({
            icon: 'info',
            title: this.$t('categoria_no_disponible_titulo') || 'Categoría no disponible',
            html: this.$t('categoria_fichaje_only_owner') || 'La categoría 4 solo está disponible cuando el ticket pertenece al usuario logueado. Seleccione otra categoría.',
            confirmButtonText: this.$t('aceptar') || 'Aceptar'
          });
        }
      } catch (e) {
        console.warn('checkCategoriaAllowedAndClear error', e);
      }
    }
    ,
    resetTicketFichaje() {
      this.ticketFichaje = {
        fecha: '',
        hora_inicio_manana: '',
        hora_fin_manana: '',
        hora_inicio_tarde: '',
        hora_fin_tarde: '',
        consentimiento: false
      };
    }
    ,
    getTodayDateString() {
      try {
        const d = new Date();
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      } catch (e) {
        return '';
      }
    }
    ,
    // Helper para formatear fechas en la descripción (DD/MM/YYYY)
    formatDateDisplay(dateStr) {
      try {
        if (!dateStr) return '';
        // Intentar parsear como ISO (YYYY-MM-DD)
        const d = new Date(dateStr);
        if (!isNaN(d.getTime())) {
          const day = String(d.getDate()).padStart(2, '0');
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const year = d.getFullYear();
          return `${day}/${month}/${year}`;
        }
        // Si no se parsea, intentar reordenar YYYY-MM-DD manualmente
        const parts = (dateStr || '').split('-');
        if (parts.length >= 3) {
          return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        return dateStr;
      } catch (e) {
        return dateStr || '';
      }
    },

    // Construye una descripción en texto plano (sin HTML) en el orden del formulario
    buildFichajeDescription() {
      try {
        const lines = [];

        // Fecha (formateada)
        if (this.ticketFichaje.fecha) {
          const formatted = this.formatDateDisplay(this.ticketFichaje.fecha);
          lines.push(`${this.$t('fecha') || 'Fecha'}: ${formatted}`);
        }

        // Turno de mañana / jornada intensiva: etiqueta y luego Inicio/Fin en líneas separadas
        const mananaInicio = this.ticketFichaje.hora_inicio_manana || '';
        const mananaFin = this.ticketFichaje.hora_fin_manana || '';
        if (mananaInicio || mananaFin) {
          const label = this.$t('turno_manana_jornada') || 'Turno de mañana / jornada intensiva';
          lines.push(label);
          if (mananaInicio) lines.push(`${this.$t('hora_inicio') || 'Hora inicio'}: ${mananaInicio}`);
          if (mananaFin) lines.push(`${this.$t('hora_fin') || 'Hora fin'}: ${mananaFin}`);
        }

        // Turno de tarde
        const tardeInicio = this.ticketFichaje.hora_inicio_tarde || '';
        const tardeFin = this.ticketFichaje.hora_fin_tarde || '';
        if (tardeInicio || tardeFin) {
          const label = this.$t('turno_tarde') || 'Turno de tarde';
          lines.push(label);
          if (tardeInicio) lines.push(`${this.$t('hora_inicio') || 'Hora inicio'}: ${tardeInicio}`);
          if (tardeFin) lines.push(`${this.$t('hora_fin') || 'Hora fin'}: ${tardeFin}`);
        }

        // Consentimiento: si está marcado, incluir el texto completo de consentimiento; si no, marcar No
        const siText = this.$t('si') || 'Sí';
        const noText = this.$t('no') || 'No';
        if (this.ticketFichaje.consentimiento) {
          // la clave 'consentimiento' contiene el texto largo del consentimiento
          lines.push(this.$t('consentimiento') || 'Confirmo que la información introducida es correcta y autorizo la modificación del fichaje.');
        } else {
          lines.push(`${this.$t('consentimiento') || 'Consentimiento'}: ${noText}`);
        }

        // Añadir la línea fija inicial solicitada
        lines.unshift('Modificación Fichaje hora');

        // Unir con saltos de línea de texto
        return lines.join('\n');
      } catch (e) {
        return this.form.descripcion || '';
      }
    },
  validateTicketFichaje() {
      try {
        // fecha obligatoria
        if (!this.ticketFichaje.fecha) {
          return { ok: false, msg: this.$t('fichaje_fecha_obligatoria') || 'La fecha es obligatoria.' };
        }

        // al menos una hora debe estar definida
        const anyHour = this.ticketFichaje.hora_inicio_manana || this.ticketFichaje.hora_fin_manana || this.ticketFichaje.hora_inicio_tarde || this.ticketFichaje.hora_fin_tarde;
        if (!anyHour) {
          return { ok: false, msg: this.$t('fichaje_hora_obligatoria') || 'Debe introducir al menos una hora.' };
        }

        // consentimiento debe estar clicado
        if (!this.ticketFichaje.consentimiento) {
          return { ok: false, msg: this.$t('fichaje_consentimiento_obligatorio') || 'Debe aceptar el consentimiento.' };
        }

        return { ok: true };
      } catch (e) {
        return { ok: false, msg: 'Validación fallida' };
      }
    },

    // Normaliza un tiempo 'HH:MM' o 'HH:MM:SS' a 'HH:MM:SS'. Devuelve null para valores vacíos.
    // Normaliza un tiempo 'HH:MM' o 'HH:MM:SS' a 'HH:MM:SS'. Devuelve null para valores vacíos.
    normalizeTimeWithSeconds(timeStr) {
      try {
        if (!timeStr || typeof timeStr !== 'string' || timeStr.trim() === '') return null;
        const parts = timeStr.split(':').map(p => p.trim());
        if (parts.length === 1) {
          return parts[0].padStart(2, '0') + ':00:00';
        }
        if (parts.length === 2) {
          const hh = parts[0].padStart(2, '0');
          const mm = parts[1].padStart(2, '0');
          return `${hh}:${mm}:00`;
        }
        // Si ya tiene segundos, asegurar formato HH:MM:SS
        const hh = parts[0].padStart(2, '0');
        const mm = (parts[1] || '00').padStart(2, '0');
        const ss = (parts[2] || '00').padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
      } catch (e) {
        return null;
      }
    },
    
  }
};
</script>

<style scoped>
.modal-content {
  background-color: white;
  border-radius: 8px;
  min-width: 40vw;
  max-width: 95vw;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  margin: 20px auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #99172A;
  color: white;
  padding: 15px 20px;
  left: 0px;
  top: 0px;
}

.modal-title {
  margin-left: 12px;
}

.modal-header .btn-close {
  margin-right: 12px;
}

.modal-title {
  margin: 0;
  font-size: 1.5rem;
}

.btn-close {
  filter: none;
  opacity: 0.95;
  color: #fff;
}

.btn-close .material-icons {
  color: #fff !important;
}

.btn-close:hover {
  opacity: 1;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.btn-primary {
  background-color: #99172A;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #7A1222;
}

.btn-primary[disabled],
.btn-primary:disabled {
  background-color: #99172A !important;
  color: #fff !important;
  opacity: 0.8;
  cursor: not-allowed;
  pointer-events: none;
  box-shadow: none !important;
}

.btn-cancel {
  background-color: #6c757d;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 44px;
  line-height: 24px;
  display: inline-block;
  vertical-align: middle;
}

.btn-cancel:hover {
  background-color: #495057;
}

.adjuntos-scroll {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  background-color: #f8f9fa;
}

.btn-elegir-archivo {
  background-color: #6c757d;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 6px 10px;
  font-size: 0.95rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 40px;
  line-height: 1;
  min-width: 0;
  width: 140px;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-elegir-archivo:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-elegir-archivo:hover:not(:disabled) {
  background-color: #495057;
}

.btn-preview {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  width: 36px;
  height: 36px;
  border-radius: 4px;
}

.btn-preview .material-icons {
  font-size: 18px;
  color: #6c757d;
}

.debug-modal-backdrop {
  pointer-events: auto;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483646;
}

.debug-modal-backdrop .modal-content { 
  pointer-events: auto; 
  z-index: 2147483647; 
}
</style>